import script from "./PostalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostalView.vue?vue&type=script&setup=true&lang=ts"

import "./PostalView.vue?vue&type=style&index=0&id=0a3dc2c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a3dc2c5"]])

export default __exports__